import React, { useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './LocalSEO.css';
import BookingForm from './BookingForm';

const LocalSEO = () => {
   const [showBookingForm, setShowBookingForm] = useState(false);

   const handleBookNow = () => {
    setShowBookingForm(true);
  };

  const handleCloseBooking = () => {
    setShowBookingForm(false);
    // Fix button color after form closes
    const buttons = document.querySelectorAll('.book-appointment-btn');
    buttons.forEach(button => {
      button.style.backgroundColor = 'var(--accent-color)';
      button.style.border = 'none';
      button.style.color = 'var(--white-color)';
    });
  };
  const bangaloreAreas = [
    'Koramangala', 'Indiranagar', 'Whitefield', 'Electronic City', 
    'Marathahalli', 'JP Nagar', 'Jayanagar', 'HSR Layout',
    'Bannerghatta Road', 'MG Road', 'Yelahanka', 'Hebbal',
    'Banashankari', 'BTM Layout', 'Malleswaram', 'Rajajinagar'
  ];

  const services = [
    'Nursing Care', 'Physiotherapy', 'Doctor Consultation', 
    'Elder Care', 'Mother & Baby Care', 'ICU Setup at Home',
    'Nursing Attendants', 'IV & IM Injection', 'Lab Tests', 'Parkinson\'s Care'
  ];

  return (
    <section className="local-seo-section py-5" id="local-seo">
      <Container>
        <h2 className="section-title text-center mb-4">Healthcare Services in Bangalore</h2>
        <p className="text-center mb-5">
          Caremetto Healthcare provides professional home healthcare services across all areas of Bangalore.
          Our team of experienced healthcare professionals is ready to serve you with quality care right at your doorstep.
        </p>
        
        <Row className="mb-5">
          <Col lg={12}>
            <Card className="service-areas-card">
              <Card.Body>
                <h3 className="mb-4">Areas We Serve in Bangalore</h3>
                <div className="areas-grid">
                  {bangaloreAreas.map((area, index) => (
                    <div key={index} className="area-item">
                      <i className="fas fa-map-marker-alt me-2"></i>
                      {area}
                    </div>
                  ))}
                </div>
                <p className="mt-4">
                  And many more areas across Bangalore! Our mobile healthcare teams can reach any location within the city.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        
        {/* <Row>
          <Col lg={12}>
            <h3 className="text-center mb-4">Our Services in Bangalore</h3>
            <div className="services-grid">
              {services.map((service, index) => (
                <Card key={index} className="service-location-card">
                  <Card.Body>
                    <h4>{service} in Bangalore</h4>
                    <p>Professional {service.toLowerCase()} services available at your home in Bangalore. Our experienced team ensures quality healthcare with personalized attention.</p>
                  </Card.Body>
                </Card>
              ))}
            </div>
          </Col>
        </Row> */}
        
        <Row className="mt-5">
          <Col lg={12}>
            <div className="local-cta">
              <h3>Need Healthcare Services in Bangalore?</h3>
              <p>Contact Caremetto Healthcare today for professional and reliable home healthcare services.</p>
              <div className="d-flex justify-content-center">
                <a href="tel:+918709530016" className="btn btn-primary me-3">
                  <i className="fas fa-phone-alt me-2"></i>Call Now
                </a>
                <a className="btn btn-outline-primary" onClick={handleBookNow}>
                  <i className="fas fa-calendar-check me-2"></i>Book Service
                </a>
              </div>
            </div>
          </Col>
        </Row>
        <BookingForm
        show={showBookingForm} 
        handleClose={handleCloseBooking} 
        defaultService="Care Giver"
         />
      </Container>
    </section>
  );
};

export default LocalSEO;
